<template>

  <div class="componentWrapper nutshell" @click="listenOut" :class="{ true: isShowing }">

    <!-- <CaseStudies></CaseStudies> -->

    <Nutshell v-in-viewport></Nutshell>

    <!-- <CaseStudies v-in-viewport></CaseStudies> -->

    <div id="ourwork" class="grid grid__item_span-12 m0 p0 homepageSec">

      <div id="filter" class="grid grid__item_span-12 m0 p0">
        <!-- Mobile -->
        <div id="filterSelect">
          <span>Filter by</span>
          <select @change="selectChange($event)" id="workFilter">
            <option id="index1" class="filterTag active" type="All-some stuff" type-id="all">All-some stuff</option>
            <option id="index2" class="filterTag" type="Website" type-id="website">Website</option>
            <option id="index3" class="filterTag" type="Digital Marketing" type-id="digital-marketing">Digital Marketing</option>
            <option id="index4" class="filterTag" type="Branding" type-id="branding">Branding</option>
            <option id="index5" class="filterTag" type="Everything in between" type-id="everything-in-between">Everything in between</option>
            <option id="index7" class="filterTag" type="Strategy and Campaigns" type-id="strategy-and-campaigns">Strategy and Campaigns</option>
          </select>
        </div>
        <!-- Desktop -->
        <p id="index1" class="filterTag active" type="All-some stuff" type-id="all" @click="showWork('All-some stuff')">All-some stuff</p>
        <p id="index2" class="filterTag" type="Website" type-id="website" @click="showWork('Website')">Website</p>
        <p id="index3" class="filterTag" type="Digital Marketing" type-id="digital-marketing" @click="showWork('Digital Marketing')">Digital Marketing</p>
        <p id="index4" class="filterTag" type="Branding" type-id="branding" @click="showWork('Branding')">Branding</p>
        <p id="index5" class="filterTag" type="Everything in between" type-id="everything-in-between" @click="showWork('Everything in between')">Everything in between</p>
        <!-- <p id="index6" class="filterTag" type="Public Relations" type-id="public-relations" @click="showWork('Public Relations')">Public Relations</p> -->
         <p id="index7" class="filterTag" type="Strategy and Campaigns" type-id="strategy-and-campaigns" @click="showWork('Strategy and Campaigns')">Strategy and Campaigns</p>
      </div>

        <div v-for="(slide, index) in list" :key="index" class="slide active" :class="{ 'casestudies' : slide.type == 'casestudy'}" :id="'slide' + index" :type="slide.tags" :style="'background-color:' + slide.backgroundColor +';'">
          <router-link :to="{ name: slide.slug.name, params: { slug: slide.slug.url, id: slide.slug.id }}" @click="setImage(index)" class="txtWhite">
            <div class="image" :style="'background-image: url(' + slide.featuredImage + ')'"></div>
            <!-- <img :src="slide.headerImageURL"/> -->
            <div class="overlay" data-swiper-parallax="-700">
              <p class="txtWhite uppercase">
                <span>{{slide.client}}</span>
              </p>
              <h2 class="txtWhite">{{slide.title}}</h2>
              <p v-if="slide.type == 'casestudy'" class="tiny">View case study</p>
              <p v-else class="tiny">View project</p>
            </div>
          </router-link>
        </div>

      <div id="casestudyFooter" class="grid grid__item_span-12 p0 m0" v-in-viewport>
        <div class="inner grid grid__item_span-9">
          <h3 class="txtWhite grid grid__item_span-12 m0 p0">Find out exactly what we can do for you.</h3>
          <router-link to="/services"><p class="txtWhite grid grid__item_span-12 m0 p0">Check out all our creative services.</p></router-link>
        </div>
      </div>

    </div>



  </div>
</template>

<script>

import Nutshell from '../components/homepage/nutshell.vue'
import CaseStudies from '../components/homepage/casestudies.vue'
import menuTransitions from '../assets/js/menu.js'
import animateScrollTo from 'animated-scroll-to'
// import hammer from 'hammerjs'
import Axios from 'axios'
var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'home',
  data () {
    return {
      pageName: '',
      list: [],
      isShowing: false,
      pageOrder: [
        '/',
        '/casestudies'
      ],
      nav: [],
      navigationDirection: 'forward'
    }
  },
  metaInfo () {
    return {
      title: 'Full Service Creative Agency',
      meta: [
        { vmid: 'description', name: 'description', content: 'A creative agency packing web, design, brands, digital marketing, and communications into one clever team. Great work going worldwide from Palmerston North.' }
      ]
    }
  },
  methods: {
    selectChange (event) {
      var tag = event.target.value
      var work = document.getElementsByClassName('slide')
      for (var z = 0; z < work.length; z++) {
        var tagString = work[z].getAttribute('type')
        if (tag === 'All-some stuff') {
          work[z].classList.add('active')
        } else if (tagString.includes(tag)) {
          work[z].classList.add('active')
        } else {
          work[z].classList.remove('active')
        }
      }
      // console.log(tag)
      if (tag === 'All-some stuff') {
        tag = 'all-some-stuff'
      }
      this.insertUrlParam('neatstuff', tag)
    },
    showWork (value) {
      var tag = value
      var filterTag = document.getElementsByClassName('filterTag')
      for (var x = 0; x < filterTag.length; x++) {
        var tagString = filterTag[x].getAttribute('type')
        // console.log(tag)
        // console.log(tagString)
        if (tagString.includes(tag)) {
          filterTag[x].classList.add('active')
        } else {
          filterTag[x].classList.remove('active')
        }
      }
      var work = document.getElementsByClassName('slide')
      for (var z = 0; z < work.length; z++) {
        tagString = work[z].getAttribute('type')
        if (tag === 'All-some stuff') {
          work[z].classList.add('active')
        } else if (tagString.includes(tag)) {
          work[z].classList.add('active')
        } else {
          work[z].classList.remove('active')
        }
      }
      if (tag === 'All-some stuff') {
        tag = 'all-some-stuff'
      }
      this.insertUrlParam('neatstuff', tag)
    },
    insertUrlParam (key, value) {
      if (history.pushState) {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.set(key, value)
        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString()
        window.history.pushState({path: newurl}, '', newurl)
      }
    },
    nextPage () {
      this.navigationDirection = 'forward'
      const currentPage = this.pageOrder.indexOf(this.$route.path)
      const nextPage = this.pageOrder[currentPage + 1]
      if (nextPage) { this.$router.push(nextPage) }
    },
    prevPage () {
      this.navigationDirection = 'reverse'
      const currentPage = this.pageOrder.indexOf(this.$route.path)
      const prevPage = this.pageOrder[currentPage - 1]
      if (prevPage) { this.$router.push(prevPage) }
    },
    processScroll (e) {
      // console.log(e)
      var topSec = document.getElementById('nutshell')
      // var middleSec = document.getElementById('caseStudies')
      var lastSec = document.getElementById('ourwork')
      var destinationWrap = ''

      if (e.deltaY < 0) {
        // this.prevPage()
        // console.log('scrolling Up')

        if (document.getElementById('ourwork').classList.contains('fully-in-viewport')) {
          // console.log(' no thing')
        } else {
          if (lastSec.classList.contains('in-viewport')) {
            lastSec.classList.add('animating')
            destinationWrap = topSec
            const options = {
              speed: 400,
              onComplete: function () {
                // lastSec.classList.remove('in-viewport')
                // middleSec.classList.add('in-viewport')
                lastSec.classList.remove('animating')
              }
            }
            animateScrollTo(destinationWrap, options)
          }
        }
      }
      if (e.deltaY > 0) {
        // this.nextPage()
        // console.log('scrolling down')

        if (topSec.classList.contains('in-viewport')) {
          topSec.classList.add('animating')
          destinationWrap = lastSec
          const options = {
            speed: 400,
            onComplete: function () {
              // topSec.classList.remove('in-viewport')
              // middleSec.classList.add('in-viewport')
              topSec.classList.remove('animating')
            }
          }
          animateScrollTo(destinationWrap, options)
        }
      }
    },
    initScroll () {
      var hashtag = window.location.hash
      // console.log(hashtag)
      if (hashtag === '#ourwork') {
        if (document.getElementById('movingHeader').classList.contains('true')) {
          // console.log('1')
          setTimeout(function () {
            var destinationWrap = document.getElementById('ourwork')
            var options = {
              speed: 1000
            }
            animateScrollTo(destinationWrap, options)
            /* document.getElementById('ourwork').classList.add('in-viewport')
            var slides = document.getElementsByClassName('slide')
            for (var b = 0; b < slides.length; b++) {
              slides[b].classList.add('in-viewport')
            } */
          }, 5000)
        } else {
          // console.log('2')
          setTimeout(function () {
            var destinationWrap = document.getElementById('ourwork')
            var options = {
              speed: 1000
            }
            animateScrollTo(destinationWrap, options)
          }, 2500)
        }
      }

      /* var mc = new hammer.Manager(window)
      var swipe = new hammer.Swipe()

      mc.add(swipe)
      mc.on('swipedown', ev => {
        this.prevPage()
      })
      mc.on('swipeup', ev => {
        this.nextPage()
      }) */

      // var scrollTimer = 0
      // var lastScrollFireTime = 0

      window.addEventListener('wheel', e => {
        /* if (this.pageOrder.indexOf(this.$route.path) + 1) {
          var minScrollTime = 1400
          var now = new Date().getTime()

          if (!scrollTimer) {
            if (now - lastScrollFireTime > minScrollTime) {
              this.processScroll(e)   // fire immediately on first scroll
              // lastScrollFireTime = now
            }
          }
        } */
        this.animateHTML().init()
      })
    },
    listenOut () { // on click this closes menu
      menuTransitions.hideHeader()
    },
    closeMenuDown () { // after timeout this closes menu
      // console.log('closing menu..........')
      setTimeout(function () {
        // menuTransitions.hideHeader()
        var appWrapper = document.body
        var wrap = document.getElementById('wrap')
        var header = document.getElementById('header')
        var moveheader = document.getElementById('movingHeader')
        var menuBtn = document.getElementById('menuBtn')
        header.classList.remove('true')
        moveheader.classList.remove('true')
        menuBtn.classList.remove('true')
        appWrapper.removeAttribute('style')
        appWrapper.style.overflowY = 'scroll'
        wrap.classList.remove('true')
        var linodes = document.getElementById('menu').childNodes
        for (var a = 0; a < linodes.length; a++) {
          // console.log(linodes[a])
          if (linodes[a].textContent !== ' ') {
            linodes[a].classList.remove('fadeIn')
          }
        }
      }, 2800)
    },
    isMenuOpen () { // on page load if menu is open it will close
      var pageHeader = document.getElementById('header')
      if (pageHeader.classList.contains('true')) {
        // console.log('yay')
        this.isShowing = true
      }
    },
    animateHTML () {
      // console.log('ready')
      var elems
      var windowHeight
      function init () {
        elems = document.querySelectorAll('.hidden')
        windowHeight = window.innerHeight
        addEventHandlers()
        checkPosition()
      }
      function addEventHandlers () {
        window.addEventListener('scroll', checkPosition)
        window.addEventListener('resize', init)
      }
      function checkPosition () {
        for (var i = 0; i < elems.length; i++) {
          var positionFromTop = elems[i].getBoundingClientRect().top
          if (positionFromTop - windowHeight <= 0) {
            elems[i].className = elems[i].className.replace(
              'hidden',
              'fade-in-element'
            )
          }
        }
      }
      return {
        init: init
      }
    },
    getData () {
      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/ourwork/?per_page=100').then(response => {
        var list = response.data.map(obj => {
          return {
            title: obj.acf.project_title,
            client: obj.acf.client_name,
            cta: obj.acf.project_cta,
            type: obj.acf.project_type,
            tags: obj.acf.project_type2,
            id: obj.id,
            featuredImage: obj.acf.featured_image.url,
            slug: {
              name: 'Project',
              url: obj.slug,
              id: obj.id
            },
            headerImageURL: obj.acf.header_image.url,
            headerImageTxt: obj.acf.header_image.alt
          }
        })

        list.forEach(el => {
          this.list.push(el)
        })

        var nav = response.data.map(obj => {
          return {
            slug: obj.slug
          }
        })
        if (nav) {
          nav.forEach(el => {
            this.nav.push(el)
          })
        }
      }).catch(function (error) {
        console.log(error)
      })
    }
  },
  beforeMount () {
  },
  mounted () {
    this.isMenuOpen()
    this.initScroll()

    this.closeMenuDown()

    document.getElementById('bsdIcon').style.opacity = 0
    document.getElementById('bsdText').style.opacity = 1

    const queryString = window.location.search
    var n = queryString.lastIndexOf('=')
    var result = queryString.substring(n + 1)

    if (result === 'website') {
      result = 'Website'
    } else if (result === 'branding') {
      result = 'Branding'
    } else if (result === 'digital-marketing') {
      result = 'Digital Marketing'
    } else if (result === 'public-relations') {
      result = 'Public Relations'
    } else if (result === 'strategy-and-campaigns') {
      result = 'Strategy and Campaigns'
    } else if (result === 'All-some-stuff' || result === 'All-some+stuff' || result === 'all-some-stuff') {
      result = 'All-some stuff'
    }

    if (queryString.includes('neatstuff')) {
      setTimeout(() => {
        var destinationWrap = document.getElementById('scrollDown')
        var options = {
          speed: 1000
        }
        animateScrollTo(destinationWrap, options)
        this.showWork(result)
        // Sort mobile
        var selectFilter = document.getElementById('workFilter').options
        for (var f = 0; f < selectFilter.length; f++) {
          var valueID = selectFilter[f].getAttribute('type')
          if (valueID === result) {
            var valueID2 = selectFilter[f].id
            document.getElementById(valueID2).selected = true
          }
        }
        console.log(result)
        if (result === 'All-some stuff') {
          var work = document.getElementsByClassName('slide')
          for (var g = 0; g < work.length; g++) {
            work[g].classList.add('active')
          }
        }
      }, 2500)
    }
  },
  components: {
    Nutshell,
    CaseStudies
  },
  created () {
    this.getData()
  },
  beforeDestroy () {
    window.addEventListener('wheel', e => {
      // console.log('removing wheel event listener')
    })
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      if (visible === true) {
        // console.log('YES')
        // this.animateElements()
      } else {
        // console.log('no luck')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
</style>



// WEBPACK FOOTER //
// src/components/Home.vue